import gql from 'graphql-tag';
import { TimeSeriesWithSettings } from '@app/pages/cmms/components/assets/asset-time-series/misc/interfaces';
import { TypedDocumentNode } from '@apollo/client/core';

export const timeSeriesFragment = gql`
	fragment TimeSeriesFragment on AssetTimeSeriesDataType {
		pk
		created
		datetime
		createdBy {
			firstName
			lastName
			smallAvatarUrl
		}
		value
	}
`;

export const getAssetDataSequenceSectionsQuery: TypedDocumentNode<
	{
		asset: {
			timeSeriesCharts: {
				edges: {
					node: TimeSeriesWithSettings;
				}[];
			};
		};
	},
	{
		assetId: string;
	}
> = gql`
	query Asset($assetId: UUID!, $sortBy: String) {
		asset(id: $assetId) {
			timeSeriesCharts(first: 100) {
				edges {
					node {
						id
						pk
						name
						description
						settings {
							benchmark
							lowerBound
							unit
							upperBound
						}
						timeSeries(sortBy: $sortBy) {
							edges {
								node {
									...TimeSeriesFragment
								}
							}
						}
					}
				}
			}
		}
	}
	${timeSeriesFragment}
`;
